import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  /** Optional right-aligned action (e.g. an import/export button). */
  action?: React.ReactNode;
};

/**
 * Consistent page header used across every screen: the title and subtitle sit
 * on a single row (separated by a thin rule) to save vertical space, with an
 * optional action on the right and a divider beneath.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action }) => (
  <Box sx={{ mb: 3 }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1.5,
      }}
    >
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}
      >
        <Typography
          variant="h6"
          color="secondary"
          fontWeight="bold"
          sx={{ whiteSpace: 'nowrap', lineHeight: 1.2 }}
        >
          {title}
        </Typography>
        {subtitle && (
          <>
            <Divider orientation="vertical" flexItem sx={{ my: 0.5 }} />
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          </>
        )}
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
    <Divider sx={{ mt: 1.5 }} />
  </Box>
);

export default PageHeader;
